import React, { useEffect, useMemo, useState } from "react";
import { FormSectionElements, FormSections, ProgramContainer } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";
import DataUtils from "../../utilities/DataUtils";
import ReCaptchaV3 from "../captcha/CaptchComponent";
import ReCaptchaButton from "../captcha/captcha-button";
import { first, last } from "lodash";

interface Props {
    token: string;
    programContainer: ProgramContainer;
    isEng: boolean;
    section: FormSections;
    onButtonClick: (data) => void; // Callback function type
    callbackStepIndex?: (index: number, returnIndex?: number) => void;
}

const HandleSubmitComponent: React.FC<Props> = ({ programContainer, isEng, section, onButtonClick, callbackStepIndex }) => {
    const [validationErrMsg, setValidationErrMsg] = useState<any[]>([]);
    const [isBusy, setIsBusy] = useState<boolean>(false);
    const [confirmationVisible, setConfirmationVisible] = useState<boolean>(false);
    const [summaryVisible, setSummaryVisible] = useState<boolean>(true);
    const [transactionId, setTransactionId] = useState<string>('');
    const [uploadReceiptSuccess, setUploadReceiptSuccess] = useState<boolean>(false);
    const [submissionError, setSubmissionError] = useState<boolean>(false);

    const handleSubmitNoRecaptha = () => {
        handleSubmit(null);
    }
    const handleSubmit = (token: string) => {
        const invalidControlList = FormValidationUtils.invalidControls(section);
        if (invalidControlList.length > 0) {
            setValidationErrMsg(invalidControlList);
            window.scrollTo(0, 0);
        } else {

            let url = programContainer.UpdateAPI;
            const data = DataUtils.collectFormValue(programContainer);
            const updateToken = programContainer.Profile?.token;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${updateToken}`
            }


            const payload = {
                "language": isEng ? "EN" : "FR",
                "userId": programContainer.Profile?.userId,
                "email": programContainer.Profile?.email,
                firstName: programContainer.Profile?.firstName,
                lastName: programContainer.Profile?.lastName,
                ...data
            };

            if (process.env.DISABLED_RECAPTCHA == "false") {
                payload["token"] = token;
            }

            payload["email"]=programContainer.Profile?.email || '';
            payload.userId = programContainer.Profile?.userId || '';

            setIsBusy(true);

            axios.post(url, payload, { headers: headers })
                .then(res => {
                    console.log(res);
                    let currentEntity = res.data?.WebResponse;
                    if (currentEntity.statusCode == 3) {
                        callbackStepIndex(8);
                        return;
                    }
                    setIsBusy(false);
                    setConfirmationVisible(true);
                    setSummaryVisible(false);
                    setTransactionId(res.data.WebResponse?.transactionId);
                    setUploadReceiptSuccess(res.data.WebResponse?.uploadReceiptSuccess);
                })
                .catch(err => {
                    setIsBusy(false);
                    setSummaryVisible(false);
                    setSubmissionError(true);
                    console.log(err);
                });
        }
    };

    const props = useMemo(() => ({
        isBusy,
        confirmationVisible,
        summaryVisible,
        transactionId,
        uploadReceiptSuccess,
        submissionError,
        validationErrMsg
    }), [isBusy, validationErrMsg]);

    useEffect(() => {
        onButtonClick(props);
    }, [props]);

    return (

        <div className="ontario-margin-top-24-!">
            {process.env.DISABLED_RECAPTCHA == 'false' && <ReCaptchaV3 lang={isEng ? 'en' : 'fr'}>
                <ReCaptchaButton key={"recaptchbutton"}
                    title={isEng ? 'Submit' : 'Soumettre'}
                    action='submitAPP'
                    buttonHandler={handleSubmit}>
                    {isEng ? "Submit" : "Soumettre"}
                </ReCaptchaButton>
            </ReCaptchaV3>}
            {process.env.DISABLED_RECAPTCHA == "true" &&
                <button onClick={handleSubmitNoRecaptha} className="ontario-button ontario-button--primary" >
                    {isEng ? 'Submit' : 'Soumettre'}
                </button>
            }
        </div>
    );
};

export default HandleSubmitComponent;
